export const KMX_TITLE_DISCLAIMER = `The title must be provided at the time of sale and all titleholders should be present. If a previously paid-off lien is listed on the title, you will need both the title and lien release from the lienholder before CarMax can purchase your car.`;

export const ESTIMATED_OFFER_DISCLAIMER = `This is not an offer, but an estimate. Offers vary based on a car's history, condition and features. Your actual offer may fall outside this range.`;

export const BRAND_DISCLAIMER_ID = 'BRAND_DISCLAIMER';
export const KMX_TITLE_DISCLAIMER_ID = 'KMX_TITLE_DISCLAIMER';
export const BRAND_DISCLAIMER_ASTERISK_ID = 'BRAND_DISCLAIMER_ASTERISK_ID';
export const KMX_TITLE_DISCLAIMER_ASTERISK_ID = 'KMX_TITLE_DISCLAIMER_ASTERISK_ID';
